import { mapState } from 'vuex';
import { routerJump } from '@/assets/js/utils.js';
const nodeUrl = require('url');
export default {
  computed: {
    ...mapState({
      State: state => state
    })
  },
  created() {
    const URL = nodeUrl.parse(location.href, true);
    const partyCode = URL.query.id || URL.query.join_id;
    const hasLogin = this.State.hasLogin;
    const isIntercomModule = this.$route.name.includes('intercom');
    if (hasLogin) {
      if (!partyCode && this.$route.name != 'globalControl' && !isIntercomModule) routerJump('manage');
    } else {
      if (isIntercomModule) return;
      routerJump('preview', {
        id: partyCode
      });
    }
  }
};